import React, { ReactNode } from 'react'

import { Layout } from 'antd'

import Footer from '../components/layout/Footer'
import Header from '../components/layout/Header'

import './LayoutStyles.less'

const { Content } = Layout

interface LayoutProps {
  children: ReactNode
  hasFooter?: boolean
}

const MainLayout: React.FC<LayoutProps> = ({ children, hasFooter = true }) => {
  return (
    <Layout>
      <Header />
      <Content className="layout-content">{children}</Content>
      {hasFooter && <Footer />}
    </Layout>
  )
}

export default MainLayout
